import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class SparkSidebarNavigationService {

	private hideSidebar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


	/**------------------------------------------------------
	 * Handle Sidebar Toggle
	 */
	showSidebar(): void {
		this.hideSidebar$.next(false);
	}

	hideSidebar(): void {
		this.hideSidebar$.next(true);
	}

	toggleSidebar(): void {
		this.hideSidebar$.next(!this.hideSidebar$.value);
	}

	getSidebarToggleObservable(): Observable<boolean> {
		return this.hideSidebar$.asObservable();
	}
}
